interface Props {
  image: {
    focalPoint?: {
      x: number;
      y: number;
    };
  };
  focusPoint?: string;
}

export const getImageAlignment = ({ image, focusPoint }: Props) => {
  if (image?.focalPoint) return `${image.focalPoint.x}% ${image.focalPoint.y}%`;

  return focusPoint || 'center center';
};
